<template>
   <div class="list_right" v-loading="loading">
        <div class="right_member_info" v-if="data != null">
            <div class="member_info_top">
               <!--<div class="imgbox">
<img :src="data.logoUrl" alt="">
   </div>-->
               <div class="info_right">
                  <div class="info_row">
                     <p><label>企业名称：</label><span>{{data.name}} <a v-if="data.isVip == 'Y'">【 VIP会员 】</a></span></p>
                     <div class="r_btns">
                        <a href="javascript:;" v-if="data.isPay == 'N'" @click="centerDialogVisible = true">缴纳会费</a>
                        <!--<a href="javascript:;">修改信息</a>-->
                        <a href="javascript:;" @click="login_out">退出账号</a>
                     </div>
                  </div>
                  <div class="info_row">
                     <p>统一社会信用代码：<span>{{data.creditCode}}</span></p>
                  </div>
                  <div class="info_row">
                     <p>企业类型：
                        <span v-if="data.companyType == '1'">会员单位</span>
                        <span v-if="data.companyType == '2'">理事单位</span>
                        <span v-if="data.companyType == '3'">常务理事</span>
                     </p>
                  </div>
                  <div class="info_row">
                     <p>所属行业：<span>{{data.industry}}</span></p>
                  </div>
               </div>
            </div>
            <div class="member_list">
               <h5>活动</h5>
               <div class="table_content">
                  <div class="tab_row">
                     <span>活动名称</span>
                     <span>活动日期</span>
                     <span>操作记录</span>
                     <span>操作</span>
                  </div>
                  <div class="tab_row" v-for="(item,index) in list">
                     <div class="tab_title">
                        <h5>
                           <router-link :to="'/user/member/info/'+item.code">{{item.title}}</router-link>
                        </h5>
                        <p>{{item.info}}</p>
                     </div>
                     <div class="tab_times">
                        <p>{{item.startTime}} ~ {{item.endTime}}</p>
                     </div>
                     <div class="tab_times">
                        <p> {{item.isJoin == 'Y' ?'已上传资料':'无'}}</p>
                     </div>
                     <div class="tab_btns">
                        <template v-if="item.status  == 1">
                           <el-upload action="" :multiple="true" list-type="text" :file-list="fileList" :auto-upload="true" :limit="fileNum" :show-file-list="false" action="" :http-request="handleUpload" ref="sdsupload" :on-preview="handlePictureCardPreview" :on-exceed="onExceed">
                              <a href="javascript:;" class="uploud_btn" @click="listActive = index">上传资料</a>
                           </el-upload>
                        </template>
                        <a href="item.documentFile" class="down_btn" v-if="item.isJoin == 'Y'">下载资料</a>
                     </div>
                  </div>
                  <el-empty description="暂无内容" v-if="list.length == 0"></el-empty>
               </div>
               <div class="list_pages" v-if="list.length > 0">
                  <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="pagecount" @current-change="handleCurrentChange">
                  </el-pagination>
               </div>
            </div>
         </div>
      <el-dialog title="" :visible.sync="centerDialogVisible" width="688px" top="20%" center :show-close="false" custom-class="member_dialog">
         <div class="dialog_container">
            <div class="iconbox">
               <img src="../../../assets/images/member/icon_news.png" alt="">
            </div>
            <div class="content_text">
               <p> 各会员单位: </p>
               <p> 北京市内部审计协会2022年度团体会员会费收缴工作已开始。根据《北京市内部审计协会会费收缴管理办法》(2018年12月第四次会员代表大会表决通过)，你单位2022年度团体会费为1000元，请于近期交至北京市内部审计协会。</p>
            </div>
            <div class="content_list">
               <div class="l_item">
                  <h5>方式一：现场交费</h5>
                  <p>地 址：北京市东城区东大地街一号红桥文创园7B楼一层</p>
               </div>
               <div class="l_item">
                  <h5>方式二：电子汇款</h5>
                  <p>单位名称：北京市内部审计协会</p>
                  <p> 账号：0200 0538 0920 0048 985</p>
                  <p> 开户行：工行方庄支行营业部</p>
               </div>
            </div>
         </div>
         <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="centerDialogVisible = false">好 的</el-button>
            <a href="javascript:;" class="r_down">下载会费通知文件</a>
         </span>
      </el-dialog>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   import {
      getCookie,
      delCookie,
      setCookie
   } from '@/assets/js/util'; // cookie操作
   export default {
      name: 'user_member_page',
      components: {},
      data() {
         return {
            loading: true,
            data:null,
            //活动列表
            list: [],
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,

            centerDialogVisible: false, //弹框
            listActive: 0, //选中的上传列表
            fileList: [],
            fileNum: 1, //文件上传个数
            uploadbox:'',//上传文件地址
         };
      },
      filters: {

      },
      mounted() {
         this.data =  JSON.parse(localStorage.getItem('userInfo'));
         if(this.data.isPay == 'N'){
            this.centerDialogVisible = true;
         }
         this.getlist();
      },
      methods: {
         getlist() {
            var _this = this;
            _this.loading = true;
            _this.$api.activityList({
               token: getCookie('sd_token'),
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         },
         //上传文件
         onExceed(){
            this.$message.error('超出最多上传数量，最多上传1个文件！');
         },
         handleUpload(event) {
            var _this = this;
            const loading = this.$loading({
               lock: true,
               text: '上传中...',
               spinner: 'el-icon-loading',
            });
            var formData = new FormData();
            formData.append('file', event.file)
            this.$api.allupload(formData).then(res => {
               loading.close();
               if (res.code == 200) {
                  _this.uploadbox = res.url;
                  _this.uploadFile(_this.uploadbox);
                  //_this.$refs['sdsupload'].clearFiles();
               } else {
                  //_this.$refs['sdsupload'].clearFiles();
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });

         },
         handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
         },
         uploadFile(url) {
            var _this = this;
            var formData = new FormData();
            this.$api.uploadActivityFile({
               token: getCookie('sd_token'),
               documentFile:url,
               activityId:_this.list[_this.listActive].id
            }).then(res => {
               if (res.code == 200) {
                  _this.$message({
                     message: '上传成功！',
                     type: 'success'
                  });
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });

         },
         login_out(){
            var _this = this;
            this.$confirm('确认退出当前账号？', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               _this.$delCookie('sd_token');
               localStorage.removeItem('userInfo');
               window.location.reload();
            }).catch(() => {

            });
         }
      }
   }
</script>
<style lang="less" scoped>

</style>
